// @flow
export const DEFAULT_GRID_DOT_SIZE = 2;
export const DEFAULT_GRID_SPACING = 36;
export const DEFAULT_EDGE_ARROW_SIZE = 8;
export const DEFAULT_EDGE_HANDLE_SIZE = 50;
export const DEFAULT_NODE_SIZE = 154;
export const DEFAULT_NODE_TEXT_MAX_TITLE_CHARS = 12;
export const DEFAULT_NODE_TEXT_LINE_OFFSET = 18;
export const DEFAULT_MAX_ZOOM = 1.5;
export const DEFAULT_MIN_ZOOM = 0.15;
export const SLIDER_STEPS = 100;
